import PatientCommunications from './patient-communications';
import './style.css';

export default PatientCommunications;
